<template>
  <Head title="Change Password" />
  <div
    class="from-navy-50 to-navy-100 relative flex min-h-screen items-center justify-center bg-gradient-to-br via-neutral-50 px-4 py-12 sm:px-6 lg:px-8"
  >
    <div
      class="from-navy-500/5 absolute inset-0 bg-gradient-to-br to-green-500/10"
    ></div>

    <div class="relative z-10 w-full max-w-md">
      <div class="rounded-2xl bg-white p-8 shadow-xl">
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.svg"
            alt="Trellis"
            class="mx-auto mb-4 h-10 w-auto"
          />
          <h1 class="text-navy-800 mb-2 text-xl font-medium">
            Create New Password
          </h1>
          <p class="text-navy-500 text-sm">Enter your new password below.</p>
        </div>

        <form
          class="space-y-6"
          @submit.prevent="form.put(`/passwords/${token}`)"
        >
          <AppInput
            v-model="form.password"
            label="New Password"
            type="password"
            placeholder="Enter new password"
            :error="form.errors.password"
            required
          />

          <AppInput
            v-model="form.password_confirmation"
            label="Confirm Password"
            type="password"
            placeholder="Confirm new password"
            :error="form.errors.password_confirmation"
            required
          />

          <AppButton type="submit" :loading="form.processing" class="w-full">
            Save Password
          </AppButton>
        </form>

        <div class="mt-6 text-center">
          <a
            href="/session/new"
            class="text-sm text-green-600 hover:text-green-700"
          >
            ← Back to Sign In
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import AppButton from "../../components/ui/AppButton.vue"
import AppInput from "../../components/ui/AppInput.vue"
import { EditPasswordFormType } from "./types"

const { token } = defineProps<{ token: string }>()

const form = useForm<EditPasswordFormType>({
  password: "",
  password_confirmation: "",
})

defineOptions({ layout: false })
</script>
